module.exports = __webpack_public_path__ + "static/media/DMT - Worlds 2.85bfb399.jpg";